<!--
  PopupDialog.vue
    Popup Dialog Component
    ※ボタン無し
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog v-model="mVisible" max-width="300px" hide-overlay>
    <div class="hm-dlg">
      <div class="hm-eid-msg">
        <slot name="msg"></slot>
      </div>
    </div>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>

export default {
  name: 'PopupDialog',
  data: () => ({
    mVisible: false,
  }),
  mounted: function () {
    this.$log.debug('# PopupDialog')
    // イベントハンドラを登録
    this.$on('show', this.show)
    this.$on('hide', this.hide)
  },
  destroyed: function () {
    this.$log.debug('# PopupDialog')
  },
  methods: {
    show: function (callback) {
      this.mVisible = true
    },
    hide: function () {
      this.mVisible = false
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-dlg {
  text-align: center;
  background-color: whitesmoke;
}
.hm-eid-msg {
  overflow-wrap: break-word;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/PopupDialog.vue